import { useRef, useState } from 'react';
import PlayIcon from './PlayIcon';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import EFVideo from '@/components/UI/EFVideo';
import { useLang } from '@/i18n';

export default function Challenges() {
    const { t } = useLang('Challenges');
    const { locale } = getLocal();

    const videoRef = useRef<any>(null);
    const [playing, setPlaying] = useState(false);

    return (
        <div className={`${styles.Challenges} GtmModuleData-section`}>
            <div className="pfa-layout">
                <div className="video-wrapper">
                    <EFVideo
                        ref={videoRef}
                        className="video fullImgs"
                        sources={['https://websiteoss.ecoflow.com/video/corporate-social-responsibility/bee6fa06e3576343d1369aa936f0b6f0.mp4']}
                        width="100%"
                        height="100%"
                        aria-label={t('secB_desc1')}
                        poster={'https://websiteoss.ecoflow.com/figma-uploads/1768469834383-bqs2z9-compressed-Frame%2027.jpg'}
                        autoPlay={false}
                        loop={false}
                        // showReplay
                        onEnded={() => setPlaying(false)}
                        muted={false}
                        // @ts-ignore
                        controls={playing}
                    />
                    {!playing && (
                        <>
                            <div
                                className="play-icon"
                                onClick={() => {
                                    setPlaying(true);
                                    videoRef.current?.play();
                                }}
                            ></div>
                            {/* <PlayIcon /> */}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
